import React from "react";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../redux/brand";
import Locales from "./locales";
import { Translation, t } from "../../../core/translate";
import Store from "./store";
import styled from "styled-components";
import { styledMedia } from "../../../components/mediaquery/breakpoints";
import cloud from "@vitalsource/vstui/colors/cloud";

const StyledFooter = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1; /* to show the box shadow on top of input fields */
  padding: 0 20px;
  min-height: 40px;
  background-color: ${cloud.getShade(1)};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

  ${styledMedia.small`
    padding: 0 10px;
  `};
`;

const PoweredBy = styled.div`
  flex: 1;

  ${styledMedia.small`
    visibility: hidden;
  `};
`;

const Actions = styled.div`
  flex: 2;
  text-align: right;
`;

const Footer = ({ showPoweredBy }) => (
  <StyledFooter>
    {showPoweredBy && (
      <PoweredBy>
        <Translation
          id="base.poweredBy-no-html"
          img={
            <img
              src="/img/vitalsource_color.svg"
              alt={t("base.brand-logo", "VitalSource Logo", {
                brand: "VitalSource"
              })}
            />
          }
        >
          Powered By VitalSource
        </Translation>
      </PoweredBy>
    )}
    <Actions>
      <Store />
      <Locales />
    </Actions>
  </StyledFooter>
);

const mapStateToProps = state => ({
  showPoweredBy: brandSelectors.getBrandValue(state, "Menu.poweredBy", true)
});

export default connect(mapStateToProps)(Footer);
